module.exports = __webpack_public_path__ + "img/1241361067.af61ac60.jpg";